import { useMediaQuery } from 'react-responsive';
import { useEffect, useState } from 'react';

import hero_img_landscape from '../../assets/images/home/hero_img_landscape.jpeg';
import hero_img_portrait from '../../assets/images/home/hero_img_portrait.jpeg';
import PlainButton from '../../components/PlainButton';




const Hero = ({ buttonSize }) => {

  const isMobile = useMediaQuery({ maxWidth: 501 });
  const isTablet = useMediaQuery({ minWidth: 501, maxWidth: 801 });
  const isDesktop = useMediaQuery({ minWidth: 801 });
  
  const [imageWidth, setImageWidth] = useState('80%');
  const [imageHeight, setImageHeight] = useState('auto');


  useEffect(() => {
    if (isMobile) {
      setImageHeight('500px');
      setImageWidth('100%')
    }

    if (isTablet) {
      setImageWidth('90%');
      setImageHeight('auto');
    }

    if (isDesktop) {
      setImageWidth('80%');
      setImageHeight('700px');
    }
  }, [isTablet, isMobile, isDesktop]);
  

  return (

    <>
    
      <div className="card text-bg-dark text-center" style={{ maxWidth: `${imageWidth}`, height: `${imageHeight}` }}>
        <img src={isDesktop ? hero_img_landscape : hero_img_portrait} className='card-img img-fluid w-100' style={{ opacity: 0.5, objectFit: 'cover', height: '100%' }} alt="Paintbrushes" />

        <div className="card-img-overlay d-flex flex-column gap-3 justify-content-center align-items-center text-wrap">
          <h1 className={`card-title font-custom text-center`}>Together, we bring your Art Alive</h1>
          <p className='card-text font-custom text-center' style={{ maxWidth: '90%' }}>
            Art classes for children, teens, and adults<br/>
            Drawing, painting, sculpture, and mixed media<br/>
            A supportive space where art comes alive<br/>
          </p>
          <p className='card-text font-custom text-center' style={{ maxWidth: '90%' }}>Art is more than learning a skill.<br/>
            It is about confidence calm and connection.<br/>
            This is where your art comes alive.
          </p>
          <div className='d-flex flex-wrap justify-content-center gap-2'>
            <PlainButton button_color='bright-main' url='/classes'>Our Classes</PlainButton>
            <PlainButton button_color='bright-main' url='/events'>Our Events</PlainButton>
          </div>
        </div>
      </div>
    
    </>

  );

}


export default Hero;